import { render, staticRenderFns } from "./ProductPayment.vue?vue&type=template&id=25f5fc36&scoped=true&"
import script from "./ProductPayment.vue?vue&type=script&lang=js&"
export * from "./ProductPayment.vue?vue&type=script&lang=js&"
import style0 from "./ProductPayment.vue?vue&type=style&index=0&id=25f5fc36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f5fc36",
  null
  
)

export default component.exports